import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=c4b24aa4&scoped=true"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"
import style0 from "./UploadImage.vue?vue&type=style&index=0&id=c4b24aa4&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b24aa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4b24aa4')) {
      api.createRecord('c4b24aa4', component.options)
    } else {
      api.reload('c4b24aa4', component.options)
    }
    module.hot.accept("./UploadImage.vue?vue&type=template&id=c4b24aa4&scoped=true", function () {
      api.rerender('c4b24aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/subgroup/UploadImage.vue"
export default component.exports